import emailjs from "@emailjs/browser";

// Initialize EmailJS with your public key
emailjs.init("1ksbR2l12BQUIo516");

export const sendContactEmail = async (formData) => {
  try {
    const response = await emailjs.send("service_tl9o3ku", "template_6d0djpj", {
      from_name: formData.name,
      from_email: formData.email,
      phone: formData.phone,
      subject: formData.subject,
      message: formData.message,
      to_name: "3E Entertainment",
      to_email: "info@3etainment.com",
    });
    return { success: true, data: response };
  } catch (error) {
    console.error("Error sending email:", error);
    return { success: false, error };
  }
};

export const subscribeToNewsletter = async (email) => {
  try {
    const response = await emailjs.send("service_tl9o3ku", "template_uxf14yf", {
      email: email,
      to_name: "3E Entertainment",
      to_email: "info@3etainment.com",
    });
    return { success: true, data: response };
  } catch (error) {
    console.error("Error subscribing to newsletter:", error);
    return { success: false, error };
  }
};

export const sendBookingInquiry = async (formData) => {
  try {
    const response = await emailjs.send("service_tl9o3ku", "template_6d0djpj", {
      from_name: formData.fullName,
      from_email: formData.email,
      phone: formData.phone,
      subject: `Booking Inquiry for ${formData.city}`,
      message: `Business/Organization: ${formData.businessName}\n\n${formData.description || "No additional details provided."}`,
      to_name: "3E Entertainment",
      to_email: "info@3etainment.com",
      cc_email: "Ashik@ashik.io",
      bcc_email: "ashikbanjade@gmail.com"
    });
    return { success: true, data: response };
  } catch (error) {
    console.error("Error sending booking inquiry:", error);
    return { success: false, error };
  }
};
